<template>
  <main class="entry-layout-content" :style="setLayoutSyl">
    <slot />
  </main>
</template>

<script>
export default {
  name: 'EntryLayoutContent',
  computed: {
    setLayoutSyl () {
      const { params: { name } } = this.$route
      if (/sso-web$/.test(name)) {
        return {
          padding: 0,
          background: '#fff'
        }
      }
      return {}
    }
  }
}
</script>

<style>
.entry-layout-content {
  flex: 1;
  min-height: 0;
  padding: 10px;
  background: #f0f2f5;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
</style>
